
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { PasswordComplexityRequest } from "@/store/my-account/types.ts";
import api from "@/services/api.service";

@Component
export default class PasswordComplexity extends Vue {
    @Prop()
    public value: string = ""; //Password - change to value to allow for use by the Generic-Update-Modal

    @Prop()
    public linkedProp: string = ""; //Username - change to linkedProp to allow for use by the Generic-Update-Modal

    @Prop()
    public readonly: boolean = false; 

    public newUser: boolean = true;
    private oldValue: string = "";
    private isValid: boolean = true;
    private complexityChecks: {[key: string]: boolean} = null;
    private showChecks: boolean = true;

    private async mounted(): Promise<any> {
        if(!this.value) this.value = "";

        this.oldValue = this.value;
        await this.checkPassword();
        this.$emit("component-loaded");
    }
    
    //Checks the password 
    private async checkPassword(){
        if(!this.readonly){
            this.complexityChecks = await api.checkPasswordComplexity({
                Username: this.linkedProp, 
                Password: this.value,
                NewUser: this.newUser
            } as PasswordComplexityRequest);

            //Check if any complexity checks have failed
            if(Object.entries(this.complexityChecks).filter(([k,v]) => v == false).length > 0) this.isValid = false;
            else this.isValid = true;

            this.$emit('validate',this.isValid);

            if(this.oldValue != this.value){
                this.oldValue = this.value;
                this.$emit("input", this.value);
            }
        }else{
            this.$emit('validate',true);
        }
    }

    //toggles whether the user can see the password or not
    private toggleShowChecks(){
        this.showChecks = !this.showChecks;
    }

    @Watch("value", { deep: true })
    private async onPasswordChange(value:string): Promise<any>{
        await this.checkPassword();
    }

    @Watch("linkedProp")
    private async onUsernameChange(): Promise<any>{
        await this.checkPassword();
    }
}
